import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from "../classNames.js";
import { sizeClassName } from "../modifiers/index.js";
export const Label = ({ children, className, size, }) => {
    const _class = classNames("label", sizeClassName(size), className);
    return _jsx("label", { className: _class, children: children });
};
